import axios from 'axios'

const API_URL = 'https://wis-back.xloo.com/api'

export function getServersList (jwt, failoverIp) {
  return axios.get(`${API_URL}/servers/${failoverIp}/`, { headers: { Authorization: `Bearer: ${jwt}` } })
}

export function postChangeServer (jwt, data) {
  return axios.post(`${API_URL}/ip/change/`, data, { headers: { Authorization: `Bearer: ${jwt}` } })
}

export function authenticate (userData) {
  return axios.post(`${API_URL}/login/`, userData)
}

export function register (userData) {
  return axios.post(`${API_URL}/register/`, userData)
}



// WEBPACK FOOTER //
// ./src/api/index.js